import BaseApi, { FetchMethodType } from 'api/BaseApi';
import { IAuthResponse } from 'api/digifi/auth/AuthTypes';

interface ISignInProcessApi {
  sendVerificationCode: (phoneNumber: string) => Promise<void>;

  verifyCode: (code: string) => Promise<IAuthResponse>;

  verifySession: (borrowerId: string) => Promise<void>;

  logout: () => Promise<void>;
}

export default class SignInProcessApi extends BaseApi implements ISignInProcessApi {
  async sendVerificationCode(phone: string): Promise<void> {
    await this.fetch<void>('/sign-in-process/send-verification-code', {
      body: { phone },
      method: FetchMethodType.POST,
    });
  }

  async verifyCode(code: string): Promise<IAuthResponse> {
    const response = await this.fetch<IAuthResponse>('/sign-in-process/verify-code', {
      body: { code },
      method: FetchMethodType.POST,
    });

    return response;
  }

  async verifySession(borrowerId: string): Promise<void> {
    await this.fetch('/sign-in-process/verify-session', {
      method: FetchMethodType.POST,
      body: { borrowerId },
    });
  }

  async logout(): Promise<void> {
    await this.fetch('/sign-in-process/logout', {
      method: FetchMethodType.DELETE,
    });
  }
}
